module.exports = __webpack_public_path__ + "static/pB0-ab75846c79ad63ca7caa69b9cc6d3570.png";